import React from 'react'

const next = () => (
  <svg width="16" height="23" viewBox="0 0 16 23">
    <path fill="#232E83" fillRule="evenodd" stroke="#232E83" strokeWidth="1.512" d="M2.435 1.825c-.383-.308-.98-.299-1.35.02-.37.32-.381.835-.024 1.166l10.372 8.945L1.06 20.59c-.357.33-.346.845.024 1.165.37.319.967.328 1.35.02L14 11.956 2.435 1.825z"/>
  </svg>
)

export default next
